var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import { AccordionGroupContext } from './AccordionGroupContext';
export const AccordionGroupProvider = ({ allowCollapse, children, externallyExpandedId, initiallyExpandedId, }) => {
    _react_refresh_temp_2();
    const [data, setData] = useState({
        allowCollapse,
        expandedId: initiallyExpandedId || externallyExpandedId || null,
        isGrouped: true,
    });
    const value = useMemo(() => [data, setData], [data]);
    const previousExternallyExpandedIdRef = useRef(externallyExpandedId);
    // Sync only on a change, so a mount does not collapse a child expanded by its own isExpanded
    useEffect(() => {
        if (initiallyExpandedId ||
            previousExternallyExpandedIdRef.current === externallyExpandedId) {
            return;
        }
        previousExternallyExpandedIdRef.current = externallyExpandedId;
        setData((prev) => ({
            ...prev,
            expandedId: externallyExpandedId || null,
        }));
    }, [externallyExpandedId, initiallyExpandedId]);
    return (_jsx(AccordionGroupContext.Provider, { value: value, children: children }));
};
_react_refresh_temp_1 = AccordionGroupProvider;
$RefreshReg$(_react_refresh_temp_1, "AccordionGroupProvider");
_react_refresh_temp_2(AccordionGroupProvider, "T/A0BguMAIxzipDVCBSI4AN9GUg=");
